export default {
  id: "caregivers",
  title: "Caregivers, Training & Compliance",
  section: "People",
  order: 80,
  keywords: "caregiver details training hours certificate compliance documents position id employee number schedule work availability create",
  body: `
## What it is

Each caregiver's Details page carries their calendar, work schedule,
training, compliance, and client access. This guide covers creating
caregivers, the fields that matter elsewhere, availability, and the two
tracking systems — training hours and compliance documents.

## Step by step: adding a caregiver

1. Caregivers → **Add New Caregiver**.
2. Name, **email**, address, phones.
3. Title, **Business Unit** (VRS / CBS / HBS / HH), and **Position ID** —
   the employee number used in state billing exports (timesheet billing
   zero-pads it to six digits). Every billable caregiver needs one.
4. **User Type** — Lead, Caregiver, or Employment Specialist — plus their
   **Lead/Manager** and **Admin** assignments. The admin assignment
   decides whose queues (time off, alerts) this caregiver appears in.
5. Set the initial **password** (8+ characters, a number, a special
   character) and create.

## Work schedule (availability)

Shifts can only be scheduled inside a caregiver's availability windows —
the shift dialog simply won't offer a caregiver outside them.

1. Open the caregiver's schedule → **Work Schedule** view.
2. Schedules are dated: create a **New Schedule** starting on a date (or
   **Duplicate** an existing one to tweak); an optional end date lets a
   temporary schedule expire.
3. Enable the weekdays they work; give each day one or more start/end
   windows (**Add Shift** adds a second window to a day).
4. Save. Caregivers can request changes; those arrive on your Dashboard
   as schedule-change requests.

## Training hours & certificates

Training hours accumulate from two directions:

- **Staff Training shifts** — a Non-Service shift with the Training code
  books the worked hours to the caregiver's training record
  **automatically** on every completion path: caregiver clock-out (with
  subject, summary, and signature), admin clock-out, approval,
  missed-shift approval — and later clock-time edits keep the hours in
  sync. Canceling or deleting the shift removes them.
- **Manual entry** — "Add Training Hours" on the caregiver page: date,
  type, hours, title, summary, optional proof document.

Every training record generates a **PDF certificate** carrying the
caregiver's running annual total — the PDF button on each record. Annual
progress is tracked against the caregiver's hire-date year.

## Compliance documents

The caregiver's Compliance tab tracks required documents (licenses, CPR,
certifications...) with statuses Pending / Approved / Expired / Rejected.

- Caregivers upload through their portal; uploads land in **Pending
  Review** on your Dashboard's compliance queue.
- Review and approve/reject from the caregiver's tab; expirations drive
  the **Expiring Soon** and **Expired** queues and automatic reminder
  emails (deactivated caregivers stop receiving them).
- Some compliance failures warn — or hard-block — clock-in, so stay ahead
  of the Expiring Soon list.

## Client access

Caregivers only see clients they've been granted access to; scheduling a
shift grants access to that client automatically. Review the Client
Access tab when someone changes teams — access is why a caregiver can or
can't see a client's CST and details.
`,
};
